import { Instance, SnapshotOut, types } from "mobx-state-tree"

/**
 * # UserEmailCert
 * 
 * UserEmailCert을 설명하세요.
 */
export const UserEmailCert = types
  .model("UserEmailCert")
  // --------------------------------------------------------------------------
  .props({
    certSid: types.maybeNull(types.optional(types.number, 0)),
    userSid: types.maybeNull(types.optional(types.number, 0)),
    certNum: types.maybeNull(types.optional(types.string, '')),
    certYn: types.maybeNull(types.optional(types.string, '')),
    regDt: types.maybeNull(types.optional(types.string, "")),
    regId: types.maybeNull(types.optional(types.number, 0)),
    updDt: types.maybeNull(types.optional(types.string, "")),
    updId: types.maybeNull(types.optional(types.number, 0)),
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model userEmailCert --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: { [key: string]: any }) => {
      const newProps = { ...self, ...props } as IUserEmailCert;
      (Object.keys(newProps) as TUserEmailCertKeys[]).forEach((key) => {
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type TUserEmailCert = Instance<typeof UserEmailCert>;
type TUserEmailCertSnapshot = SnapshotOut<typeof UserEmailCert>

export interface IUserEmailCert extends TUserEmailCert { }
export type TUserEmailCertKeys = keyof TUserEmailCertSnapshot & string;
export interface IUserEmailCertSnapshot extends TUserEmailCertSnapshot { }
export const createUserEmailCert = () =>
  types.optional(UserEmailCert, {} as TUserEmailCert);
